export default "__VITE_PUBLIC_ASSET__b5f967df__"